import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Modal } from './Modal.jsx';
import { IpLookupSection } from '../../pages/tools/ip-lookup/IPLookup.jsx';
import { MacOUIRow } from '../../pages/tools/mac-lookup/MacLookup.jsx';
import { useAuth } from '../../contexts/AuthContext.jsx';
// Clase base de los botones
const buttonClassNames =
  'w-full px-4 py-4 bg-gray-100 text-gray-700 border-b-4 border border-gray-200 hover:border-gray-400 hover:bg-gray-200 flex items-center justify-center text-lg font-semibold rounded-lg shadow transition-all cursor-pointer';

// Botón para crear nuevas pestañas (tickets)
export function CreateNewTabsButton() {
  return (
    <Link to="/createTickets" className={buttonClassNames}>
      New Ticket
    </Link>
  );
}

// Botón para ver tickets del usuario
export function MyTicketsButton() {
  const { user } = useAuth();

  return (
    <Link
      to={user?.id ? '/shared-tickets' : '#'}
      className={
        buttonClassNames + (user?.id ? '' : ' pointer-events-none opacity-50')
      }
    >
      All Tickets
    </Link>
  );
}

// Botón para ver tickets del usuario v2 con diseño hump
export function MyTicketsHumpButton() {
  const { user } = useAuth();

  return (
    <Link
      to={user?.id ? '/smart-ticket' : '#'}
      className={
        buttonClassNames + (user?.id ? '' : ' pointer-events-none opacity-50')
      }
    >
      Go to ticket
    </Link>
  );
}

// Botón para crear cliente
export function CreateCustomerButton() {
  return (
    <Link to="/customers" className={buttonClassNames}>
      Customers Table
    </Link>
  );
}

// Botón para calculadora CIDR
export function CidrCalculatorButton() {
  return (
    <Link to="/cidr" className={buttonClassNames}>
      CIDR Calculator
    </Link>
  );
}

export function WhoisButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button onClick={() => setOpen(true)} className={buttonClassNames}>
        ISP Lookup
      </button>

      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <h2 className="text-xl font-bold mb-4 text-black">ISP Lookup</h2>
        <p className="mb-4 text-black">
          Enter IP Address to see the ISP - Internet Service Provider
        </p>
        <div className="flex flex-col md:flex-row gap-6">
          <IpLookupSection label="WAN1" />
          <IpLookupSection label="WAN2" />
        </div>
      </Modal>
    </>
  );
}

export function OUIButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button onClick={() => setOpen(true)} className={buttonClassNames}>
        Manufacturer Lookup
      </button>

      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <h2 className="text-xl font-bold mb-4 text-black">
          Manufacturer Lookup
        </h2>
        <p className="mb-4 text-black">
          Enter your MAC address to see the manufacturer
        </p>
        <div className="flex flex-col">
          <MacOUIRow index={1} />
          <MacOUIRow index={2} />
        </div>
      </Modal>
    </>
  );
}

// Botón para herramienta X-Ray
export function XRayButton() {
  return (
    <Link to="/xray" className={buttonClassNames}>
      X-Ray
    </Link>
  );
}

// Botón para herramienta Bicom
export function BicomButton() {
  return (
    <Link to="/bicom" className={buttonClassNames}>
      Bicom Tool
    </Link>
  );
}

function Dashboard() {
  return (
    <div className="flex gap-4 p-4 w-5/6 mx-auto mt-4">
      <CreateNewTabsButton />
      <MyTicketsButton />
      <CreateCustomerButton />
      <CidrCalculatorButton />
      <XRayButton />
    </div>
  );
}

export default Dashboard;
